import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

const SLICE_NAME = 'dealers/views/.components/dealerAlertLogsTab/redux';

const INIT_STATE = {
    resendLoading: false,
    resendResult: null,
    resendError: false,
};

export const resendDealerAlertLog = createAsyncThunk(
    `${SLICE_NAME}/resendDealerAlertLog`,
    async (payload, { rejectWithValue }) => {
        try {
            const { dealerId, logId } = payload;

            const response = await clientMutation(
                `mutation resendDealerAlertLog($dealerId: Int!, $logId: Int!) {
                    result: resendDealerAlertLog(dealerId: $dealerId, logId: $logId)
                }`,
                { dealerId, logId },
                endpoints.GRAPHQL_GENERAL
            );

            return { logId, success: response?.result };
        } catch (exc) {
            ExceptionManager(exc, `${SLICE_NAME}/resendDealerAlertLog`, 'resendDealerAlertLog');
            return rejectWithValue(exc.message || 'Failed to resend alert');
        }
    }
);

export const dealerAlertLogsTabSlice = createSlice({
    name: SLICE_NAME,
    initialState: INIT_STATE,
    reducers: {
        reset(state) {
            return { ...INIT_STATE };
        },
        resetResend(state) {
            state.resendLoading = false;
            state.resendResult = null;
            state.resendError = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(resendDealerAlertLog.pending, (state) => {
                state.resendLoading = true;
                state.resendError = false;
            })
            .addCase(resendDealerAlertLog.fulfilled, (state, action) => {
                state.resendLoading = false;
                state.resendResult = action.payload;
            })
            .addCase(resendDealerAlertLog.rejected, (state) => {
                state.resendLoading = false;
                state.resendError = true;
            });
    }
});

export const { reset, resetResend } = dealerAlertLogsTabSlice.actions;
export default dealerAlertLogsTabSlice.reducer;
